<template>
	<div id="pageRoot">

		<p class="textBase appearAnimationB" id="text01" style="z-index: 6">
			Lee los globos.<br><br>
			Dibuja los personajes y escribe<br>
			quién lo dijo.
		</p>

		<div class="text-box-a pageElement hover-animation-a" id="textBox01" style="z-index: 3;">
			<p class="textBase" id="textBox01Text">
				¡Ya estás por<br>aprender a volar! 
			</p>
		</div>
		<!--BUTTONS----------------------------------------------------------------------------------------------------->		
		<!--BUTTONS--------------------------------------------------------------------------------------------------------->

		<!-- TEXTS ----------------------------------------------------------------------------------------------------->
		<!-- TEXTS ----------------------------------------------------------------------------------------------------->
		<div class="basicItem01" id="tagVenancio" style="z-index: 3; background-image: url(/pages/img/sordo/svgPage71TagShort.svg); background-size:cover;">
			<p class="textBase tagText">
				Venancio.
			</p>
		</div>
		<div class="basicItem01" id="tagLosChicos" style="z-index: 3; background-image: url(/pages/img/sordo/svgPage71TagShort.svg); background-size:cover;">
			<p class="textBase tagText">
				Los chicos.
			</p>
		</div>
		<div class="basicItem01" id="tagLosVecinos" style="z-index: 3; background-image: url(/pages/img/sordo/svgPage71TagLong.svg); background-size:cover;">
			<p class="textBase tagText">
				Los vecinos del barrio.
			</p>
		</div>
		<div class="basicItem01" id="tagDonFito" style="z-index: 3; background-image: url(/pages/img/sordo/svgPage71TagShort.svg); background-size:cover;">
			<p class="textBase tagText">
				Don Fito.
			</p>
		</div>


		<uploaded-image class="image01 pageElement" v-bind:page="$parent.page" v-bind:type="$parent.type" number=1></uploaded-image>


		<div style="position: absolute; margin-left: 52%; margin-top: 55.5%; z-index: 5">
			<image-upload v-bind:page="$parent.page" v-bind:type="$parent.type" number=1></image-upload>
		</div>


		<!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
		<span id="fixedBackground" class="pageElement"></span>
		<span class="footer-page footer-write"></span>
		<!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
	</div>
</template>
<style scoped>
#fixedBackground
{
position: absolute;
width: 973.21px;
height: 724px;
left: 19.29px;
top: 14px;
background-image: url(/pages/img/sordo/svgPage71Background.svg);
}
.tagText{
position: absolute;
left: 0px;
right: 0px;
top: 5px;
bottom: 0px;

font-size: 36px;
line-height: 49px;
text-align: center;

color: #FEFAFA;
}

#text01
{
position: absolute;
width: 420px;
height: 86px;
left: 56px;
top: 101px;

font-style: normal;
font-weight: normal;
font-size: 24px;
line-height: 25px;
}

#textBox01
{
position: absolute;
width: 440px;
height: 175.65px;
left: 600px;
top: 145px;
background-image: url(/pages/img/sordo/svgPage71TextBox01.svg);
background-size:contain;
background-repeat: no-repeat;
}
#textBox01Text
{
position: absolute;
width: 400px;
height: 49px;
left: 60px;
top: 6px;

font-size: 36px;
line-height: 49px;

color: #FBF8F8;
}
#tagVenancio{
position: absolute;
width: 217.67px;
height: 70.55px;
left: 19px;
top: 260px;
}
#tagLosChicos{
position: absolute;
width: 224px;
height: 70.55px;
left: 275px;
top: 260px;
}
#tagLosVecinos{
position: absolute;
width: 482px;
height: 70.55px;
left: 19px;
top: 360px;
}
#tagDonFito{
position: absolute;
width: 217.67px;
height: 70.55px;
left: 19px;
top: 460px;
}
.image01{
position: absolute;
width: 462px;
height: 305px;
left: 520px;
top: 288px;
}
</style>
<script>
export default {
  data() {
    return {
      videos: ["p71-74/V48.mp4", "p71-74/V49.mp4", "p71-74/V50.mp4", "p71-74/V51.mp4", "p71-74/V52.mp4", "p71-74/V53.mp4", "p71/V56.mp4"]
    }
  }
}
</script>